import { ChevronLeft, Plus } from "lucide-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"
import { useMediaQuery } from "@/hooks/use-media-query.ts"

interface Props {
  navigateTo: string
  title: string
  onIconClick?: () => void
  onBackClick?: () => void
  icon?: React.ReactNode
  titleInfo?: React.ReactNode
  rightContent?: React.ReactNode
}

const DesktopTopBar: React.FC<Props> = ({
  title,
  navigateTo,
  icon,
  onBackClick,
}) => {
  const navigate = useNavigate()
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const { t } = useTranslation()

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick()
    } else {
      navigate(-1)
    }
  }

  if (!isDesktop) return null

  return (
    <div className="mb-4 flex w-full flex-col items-center justify-between gap-10">
      <div className="flex w-full items-center justify-between">
        <div
          className="group grid cursor-pointer place-content-center rounded-full border-2 border-neutral-800 p-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brown)] focus-visible:ring-offset-1 [@media(hover:hover)]:hover:border-brown-500 [@media(hover:hover)]:hover:bg-brown-500"
          onClick={handleBackClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
              e.preventDefault()
              handleBackClick()
            }
          }}
        >
          <ChevronLeft className="h-5 w-5 transition-colors [@media(hover:hover)]:group-hover:text-white" />
        </div>
        <Link
          to={navigateTo}
          className="group grid place-content-center rounded-full border-2 border-neutral-800 p-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brown)] focus-visible:ring-offset-1 [@media(hover:hover)]:hover:border-brown-500 [@media(hover:hover)]:hover:bg-brown-500"
        >
          {icon ? (
            icon
          ) : (
            <Plus className="h-5 w-5 transition-colors [@media(hover:hover)]:group-hover:text-white" />
          )}
        </Link>
      </div>
      <div className="flex w-full items-start gap-2">
        <p className="text-3xl font-semibold text-neutral-700">{t(title)}</p>
      </div>
    </div>
  )
}

export default DesktopTopBar
